import React from 'react'

function InfoliniaNumbers() {


    return (

        <div className="info-tel">
          <a href="tel:+48801167536" title="Call the Helpline">
            801 167 536
          </a>
          <a href="tel:+48502167536" title="Call the Helpline">
            502 167 536
          </a>
        </div>
    )
}

export default InfoliniaNumbers
